export default "__VITE_ASSET__0faf8890__"